module Check
{
	export function construct()
	{
		$("[data-check=all]").click((event) => {
			const element = $(event.target);
			const newValue = element.is(':checked');
			const table = getTargetTable(element);
			const checkboxes = getCheckBoxes(table);
			checkboxes.prop("checked", newValue);
		});

		$("[data-check=odd").click((event) => {
			const element = $(event.target);
			const table = getTargetTable(element);
			const checkboxes = getCheckBoxes(table);
			const newValue = element.is(':checked');

			let even = true;
			for (let i = 0; i < checkboxes.length; i++)
			{
				if (even)
				{
					$(checkboxes[i]).prop("checked", newValue);
				}
				else
				{
					$(checkboxes[i]).prop("checked", !newValue);
				}
			}
		});
	}

	function getTargetTable(element: JQuery<HTMLElement>)
	{
		if (element.data("checktable"))
		{
			return $(element.data("checktable"));
		}
		return element.closest("table");
	}

	function getCheckBoxes(table: JQuery<HTMLElement>)
	{
		return table.find("input[type=checkbox]");
	}
}